import TableTemplate from "../../../TableTemplate/tableTemplate";
import { IDetailedStateAdjustmentTablesSearchParam } from "../../../../Interfaces/deltaHedgeExe";
import { CommonTableUI } from "../../../TableTemplate/common";
import { getDetailedStateAdjustmentDeltaTable } from "../../../../Requests/adjustment";

interface IProps {
  searchParams: IDetailedStateAdjustmentTablesSearchParam;
}

const Delta = ({ searchParams }: IProps) => {
  return (
    <TableTemplate<IDetailedStateAdjustmentTablesSearchParam, any>
      TableUI={({ reports, onAction }) => (
        <CommonTableUI
          reports={reports}
          onAction={onAction}
          tableBoxClassName="!max-h-[300px] order-table"
        />
      )}
      getDataTable={getDetailedStateAdjustmentDeltaTable}
      initialSearchParameters={searchParams}
    />
  );
};

export default Delta;
